import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#0f0852',
                secondary: '#FFF',
                accent: '#afd07b'
            }
        }
        
    }
});
